import "./SearchForm.scss";
import Checkout from "./Checkout";
import FormHeader from "./FormHeader";
import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "services/auth.service";
import ServiceClassTabs from "./ServiceClassTabs";
import AdditionalInfoForm from "./AdditionalInfoForm";
import BookingService from "services/booking.service";
import ToasterService from "utils/toaster.util";
import LocalStorage from "utils/localstorage.util";
import { classActions } from "redux/slices/class";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { change } from "redux-form";
import format from "date-fns/format";
import { bookingActions } from "redux/slices/booking";
import { MODAL, modalActions } from "redux/slices/modal";
import { paymentActions } from "redux/slices/payment";
import {
  isYeloCheckoutSession,
  PARTNER_CHECKOUT_STORAGE_KEY,
  partnerHomePath,
  withPartnerToken,
} from "utils/partnerSession.util";

let hashTags: any = {
  1: "classes",
  2: "additional-form",
  3: "checkout",
}

const hashToPage: any = {
  "classes": 1,
  "additional-form": 2,
  "checkout": 3,
};

export default function SearchForm() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(1);
  const bookingFormPayload = LocalStorage.getItem("BookingFormPayload");
  const AdditionalFormPayload = LocalStorage.getItem("AdditionalInfoForm");
  const classsPrice = useAppSelector((state) => state.classes.classsPrice);

  useEffect(() => {
    LocalStorage.setFormValues("SearchForm", dispatch);
    LocalStorage.setFormValues("AdditionalInfoForm", dispatch);
    LocalStorage.setFormValues("PickUpForm", dispatch);
  }, [dispatch]);

  // Initialize page from current hash on mount
  useEffect(() => {
    const currentHash = window.location.hash.replace('#', '');
    if (currentHash && hashToPage[currentHash] && hashToPage[currentHash] !== page) {
      setPage(hashToPage[currentHash]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Respond to hash changes (e.g., back/forward navigation)
  useEffect(() => {
    const onHashChange = (): void => {
      const hash = window.location.hash.replace('#', '');
      const targetPage = hashToPage[hash] || 1;
      setPage(targetPage);
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  // useEffect(() => {
  //   StripLoaderService.getStripeInstance();
  // }, []);

  useEffect(() => {
    const getBookingPrices = async () => {
      const data = LocalStorage.getItem("BookingFormPayload");

      if (!data) return navigate(isYeloCheckoutSession() ? partnerHomePath() : "/");

      const [success]: any = await BookingService.getBookingPrices(data);

      if (success) {
        const { classes, distance, isStripe, aggregator, user } =
          success.data.data;

        if (classes.length === 0)
          ToasterService.showError(`No classes in ${data.city_name[0]}`);
        else {
          let bookingFormPayload = LocalStorage.getItem("BookingFormPayload");
          bookingFormPayload.isStripe = isStripe ? true : false;
          bookingFormPayload.aggregator = aggregator ? true : false;
          LocalStorage.setItem("user", user);
          LocalStorage.setItem("BookingFormPayload", bookingFormPayload);
          dispatch(change("SearchTripForm", "distance", distance));
          return dispatch(classActions.setClassesPrices(classes));
        }
      }

      navigate(isYeloCheckoutSession() ? partnerHomePath() : "/");
    };

    getBookingPrices();
  }, [dispatch, navigate]);

  useEffect(
    () =>
      window.scrollTo({
        top: 0,
        behavior: "auto",
      }),
    [page]
  );

  const prevPage = () => {
    let pageValue = page - 1
    setPage(page - 1)
    navigate(
      isYeloCheckoutSession()
        ? withPartnerToken(`/search-form#${hashTags[pageValue]}`)
        : `/search-form#${hashTags[pageValue]}`
    );

  };
  const nextPage = () => {
    let pageValue = page + 1
    setPage(pageValue);
    navigate(
      isYeloCheckoutSession()
        ? withPartnerToken(`/search-form#${hashTags[pageValue]}`)
        : `/search-form#${hashTags[pageValue]}`
    );
  };

  const handleSubmit = async (values: any) => {
    console.log(values);

    const data = { ...values };
    const date = new Date(data.date.date).toDateString();
    const time = data.time;

    data.added_from = "website";

    data.payment_type = "s";
    data.time_stamp = format(
      new Date(`${date} ${time}`),
      "yyyy-MM-dd HH:mm:ss"
    );
    const splitDate = data.time_stamp.split(" ");
    data.time_stamp = `${splitDate[0]}T${splitDate[1]}.000Z`;
    data.booking_for_someone = true;

    if (data.booking_for_someone) {
      if (data.phoneNumber?.data) {
        data.phoneNumber = `+${values.phoneNumber.value}`;
        data.country = values.phoneNumber.data.countryCode;
        data.country_code = `+${values.phoneNumber.data.dialCode}`;
      }

      const {
        phone,
        email,
        title,
        country,
        last_name,
        first_name,
        country_code,
      } = AdditionalFormPayload;

      data.booking_for_details = {
        phone: phone?.value || "",
        email,
        title,
        country,
        last_name,
        first_name,
        country_code: country_code || "country_code",
      };
    }

    data.trip_type = "hourly";
    data.pickup_type = data?.pickup?.details?.airport ? "airport" : "place";

    data.city_name = [data?.pickup?.details?.city];

    const { pickup, destination } = data;
    // const pickupSuggestion = {
    //   name: pickup?.details?.name,
    //   title: pickup?.details?.name,
    //   place_id: pickup?.details?.place_id,
    //   address: pickup?.details?.formatted_address,
    //   city: pickup?.details?.city,
    //   country_name_code: pickup?.details?.country_name_code,
    //   isPriorityCountry: pickup?.details?.isPriorityCountry || false,
    //   isRuhAirport: pickup?.details?.airport || false,
    //   coordinates: {
    //     lat: pickup?.details?.geometry?.location?.lat,
    //     lng: pickup?.details?.geometry?.location?.lng,
    //   },
    //   types: pickup?.details?.types || [],
    //   score: pickup?.score || 0,
    // };

    // let destinationSuggestion:any = null;
    // if (destination?.details) {
    //   destinationSuggestion = {
    //     name: destination?.details?.name,
    //     title: destination?.details?.name,
    //     place_id: destination?.details?.place_id,
    //     address: destination?.details?.formatted_address,
    //     city: destination?.details?.city,
    //     country_name_code: destination?.details?.country_name_code,
    //     isPriorityCountry: destination?.details?.isPriorityCountry || false,
    //     isRuhAirport: destination?.details?.airport || false,
    //     coordinates: {
    //       lat: destination?.details?.geometry?.location?.lat,
    //       lng: destination?.details?.geometry?.location?.lng,
    //     },
    //     types: destination?.details?.types || [],
    //     score: destination?.score || 0,
    //   };
    // }

    if (data?.pickup) {
      data.pickup = {
        title: pickup?.details?.name,
        place_id: pickup?.details?.place_id,
        address: pickup?.details?.formatted_address,
        coordinates: {
          lat: pickup?.details?.geometry?.location?.lat,
          lng: pickup?.details?.geometry?.location?.lng,
        },
      };
    }

    if (
      bookingFormPayload?.trip_type === "trip" ||
      bookingFormPayload?.trip_type === "city_trip"
    ) {
      // if (data?.destination) {
      const locationDistination = data.destination.details?.geometry?.location;
      data.trip_type =
        bookingFormPayload?.trip_type === "trip" ? "trip" : "city_trip";
      data.city_name.push(data?.destination?.details?.city);
      data.destination = {
        title: destination?.details?.name,
        place_id: destination?.details?.place_id,
        address: destination?.details?.formatted_address,
        coordinates: {
          lat: destination?.details?.geometry?.location?.lat,
          lng: destination?.details?.geometry?.location?.lng,
        },
      };
      data.destinationCoordinates = [
        locationDistination.lat,
        locationDistination.lng,
      ];
      data.pickup_type =
        data.pickup_type == "airport"
          ? "airport"
          : destination?.details.airport
            ? "airport"
            : "place";

      delete data.duration;
    } else {
      data.duration = Number(data.duration);
      delete data.destination;
    }
    const { location } = pickup?.details?.geometry;
    data.coordinates = [[location.lng, location.lat]];
    data.pickupCoordinates = [location.lat, location.lng];
    data.additional_info = {
      notes: data.notes,
      pickup_sign: data.pickup_sign,
      child_seats: data.child_seats,
    };
    data.business_partner_details = {
      name: "jeeny",
      user_id: LocalStorage.getItem("user")?.user_id || "",
    };
    data.currency = {
      currency_short: classsPrice.price_details.currency_sign,
      currency_sign: classsPrice.price_details.currency_sign,
    };

    // data.pickupSuggestion=pickupSuggestion
    // data.destinationSuggestion=destinationSuggestion



    delete data.date;
    delete data.time;
    delete data.phoneNumber;
    delete data.email;
    delete data.title;
    delete data.notes;
    delete data.country;
    delete data.last_name;
    delete data.first_name;
    delete data.pickup_sign;
    delete data.child_seats;
    delete data.country_code;

    const [success]: any = await BookingService.addBooking(data);

    if (!success) return;

    const responseData = success.data.data;
    const {
      redirect_link,
      trip_id,
      use_yelo_checkout,
      price,
      currency,
      client_secret,
      form,
    } = responseData;

    dispatch?.(bookingActions.setLoading(false));
    dispatch?.(modalActions.closeModal());

    const payfortForm = client_secret || form;

    if (isYeloCheckoutSession() && use_yelo_checkout && trip_id && payfortForm) {
      dispatch?.(
        paymentActions.setPrice({
          price,
          currency: currency || "SAR",
        })
      );
      LocalStorage.setItem(PARTNER_CHECKOUT_STORAGE_KEY, {
        trip_id,
        payfort_form: payfortForm,
        client_secret: payfortForm,
        form: payfortForm,
        price,
        currency,
      });
      navigate(withPartnerToken(`/payment-form?order=${trip_id}`));
      return;
    }

    if (redirect_link) window.location.replace(redirect_link);
  };

  return (
    <>
      <FormHeader page={page} prevPage={prevPage} />
      <Container maxWidth="lg">
        {page === 1 && <ServiceClassTabs onSubmit={nextPage} />}
        {page === 2 && <AdditionalInfoForm onSubmit={nextPage} />}
        {page === 3 && <Checkout onSubmit={handleSubmit} />}
      </Container>
      <div id="payment_form_div"></div>
    </>
  );
}
